import React, { useState, useContext, useEffect } from 'react';
import AuthContext from '../../context/AuthContext';
import axios from 'axios';

function OnboardingComplete() {
    const [status, setStatus] = useState(null);
    const { userId, user } = useContext(AuthContext);
    useEffect(() => {
        const initialHandle = async () => {
            console.log(user);
            const response = await axios.get(`${process.env.REACT_APP_API_URL_LOCAL}/api/stripe/account-status/${user?.stripeAccountId}`);
            console.log(response.data);
            setStatus(response.data.status);
        }
        if(user && userId) initialHandle()
    }, [userId]);

    return (
    <div>
        <h2>Stripe Setup Complete</h2>
        {status ? (
        <p>Your account status: {status ? 'done' : 'not done'}</p>
        ) : (
        <p>Checking account status...</p>
        )}
    </div>
    );
    }

    export default OnboardingComplete;